import _ from 'lodash';
import { AnyAction } from 'redux';

import { type CustomRouterHistory } from '../../../createHistory';
import { UserActionTypes } from '../../../types/actions/user';
import RoutesRedirectionFactory from '../../../utils/routes/RoutesRedirectionFactory';
import { LocalStorageMissionsKeys } from '../constants/storage';
import { UserMissionsStateActionTypes } from '../types/actions/userMissions';
import { type UserMissions } from '../types/state/userMissions';

export const userMissionsInitialState: UserMissions = {};

const actionTypesToReactOn = [
  UserMissionsStateActionTypes.UPDATE_STATE,
  UserMissionsStateActionTypes.UPDATE_REGISTERED_MISSIONS,
  UserMissionsStateActionTypes.REFRESH_USER_MISSIONS_STATE,
  UserActionTypes.SET_DISCONNECTED,
];

const makeUserMissionsReducer =
  (history: CustomRouterHistory) =>
  (state: UserMissions = userMissionsInitialState, action: AnyAction): UserMissions => {
    const { type, payload = {} } = action;

    if (actionTypesToReactOn.indexOf(type) !== -1) {
      const { location } = history ?? {};
      const { pathname, hash } = location ?? {};

      if (type === UserMissionsStateActionTypes.UPDATE_STATE) {
        const { userMissionsMutation = {} } = payload;

        const nextState = {};
        _.mergeWith(nextState, state, userMissionsMutation, (objValue, srcValue) => {
          if (_.isArray(srcValue)) {
            return srcValue;
          }
        });

        if (
          pathname.indexOf(RoutesRedirectionFactory.getExtrasRoutePathname()) !== -1 ||
          hash.indexOf('mission') !== -1
        ) {
          localStorage.setItem(LocalStorageMissionsKeys.USER_MISSIONS, JSON.stringify(nextState));
        }

        return nextState;
      }

      if (type === UserMissionsStateActionTypes.UPDATE_REGISTERED_MISSIONS) {
        const { registeredMissionsMutation = [] } = payload;

        const nextState = { ...state };

        for (const missionId of registeredMissionsMutation) {
          const currentMissionState = nextState[missionId];

          if (currentMissionState) {
            if (!currentMissionState.hasUserRegistered) {
              nextState[missionId] = { ...currentMissionState, hasUserRegistered: true };
            }
          } else {
            nextState[missionId] = { missionId, hasUserRegistered: true };
          }
        }

        if (
          (pathname && pathname.indexOf(RoutesRedirectionFactory.getExtrasRoutePathname()) !== -1) ||
          (hash && hash.indexOf('mission') !== -1)
        ) {
          localStorage.setItem(LocalStorageMissionsKeys.USER_MISSIONS, JSON.stringify(nextState));
        }

        return nextState;
      }

      if (type === UserMissionsStateActionTypes.REFRESH_USER_MISSIONS_STATE) {
        return { ...state };
      }

      if (type === UserActionTypes.SET_DISCONNECTED) {
        localStorage.removeItem(LocalStorageMissionsKeys.USER_MISSIONS);
        return {};
      }
    }

    return state;
  };

export default makeUserMissionsReducer;
